import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/icon_filterWord.svg'
import _imports_1 from '@/assets/images/icon_filterUniv.svg'
import _imports_2 from '@/assets/images/icon_filterFaculty.svg'
import _imports_3 from '@/assets/images/icon_filterTeacher.svg'


const _hoisted_1 = { class: "p-result__filterSearch__input" }
const _hoisted_2 = { class: "-Filterlabel" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "関心ワード"
}, null, -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "p-result__filterSearch__relatedSearch",
  id: "js-relatedSearch"
}
const _hoisted_6 = {
  key: 0,
  class: "-RelatedSearchTitle"
}
const _hoisted_7 = {
  class: "-RelatedSearchWord -OneLiner",
  id: "js-relatedWords"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "-RelatedSearchToggle",
  id: "js-wordsToggleOpen"
}, "すべて表示", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "-RelatedSearchToggle",
  id: "js-wordsToggleClose"
}, "閉じる", -1)
const _hoisted_11 = { class: "-Filterlabel" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "大学名"
}, null, -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "-Filterlabel" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "学部・学科名"
}, null, -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "-Filterlabel" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "先生名"
}, null, -1)
const _hoisted_19 = ["value"]

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        class: "c-input__text -FilterWord",
        type: "text",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:Kw', $event.target.value))),
        placeholder: "関心ワードで探す",
        name: "Kw",
        value: _ctx.Kw
      }, null, 40, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (this.relatedSearch.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "関連検索："))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.relatedSearch, (word) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (_ctx.onClickRelatedWordsSet(_ctx.abc123ToHAN(word))),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:Kw', $event.target.value)))
          }, _toDisplayString(_ctx.abc123ToHAN(word)), 41, _hoisted_8))
        }), 256))
      ]),
      _hoisted_9,
      _hoisted_10
    ]),
    _createElementVNode("label", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("input", {
        class: "c-input__text -FilterUniv",
        type: "text",
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:Dg', $event.target.value))),
        placeholder: "大学名で探す",
        name: "Dg",
        value: _ctx.Dg
      }, null, 40, _hoisted_13)
    ]),
    _createElementVNode("label", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("input", {
        class: "c-input__text -FilterFaculty",
        type: "text",
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:Gb', $event.target.value))),
        placeholder: "学部・学科名で探す",
        name: "Gb",
        value: _ctx.Gb
      }, null, 40, _hoisted_16)
    ]),
    _createElementVNode("label", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("input", {
        class: "c-input__text -FilterTeacher",
        type: "text",
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:Kj', $event.target.value))),
        placeholder: "先生名で探す",
        name: "Kj",
        value: _ctx.Kj
      }, null, 40, _hoisted_19)
    ])
  ]))
}